import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_3 = { class: "symbol symbol-35px symbol-circle" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "ms-3" }
const _hoisted_6 = {
  href: "#",
  class: "fs-5 fw-bold text-gray-900 text-hover-primary me-1"
}
const _hoisted_7 = { class: "text-muted fs-7 mb-1" }
const _hoisted_8 = {
  key: 1,
  class: "me-3"
}
const _hoisted_9 = { class: "text-muted fs-7 mb-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold text-gray-900 text-hover-primary ms-1" }, "You", -1)
const _hoisted_11 = { class: "symbol symbol-35px ms-1 symbol-circle" }
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`d-flex justify-content-${_ctx.isOwn ? 'end' : 'start'} ${_ctx.messageData.is_group ? '' : 'mt-10'}`)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`d-flex flex-column align-items-${_ctx.isOwn ? 'end' : 'start'}`)
    }, [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.isOwn && !_ctx.messageData.is_group)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  alt: "Pic",
                  src: _ctx.messageData.user.photo
                }, null, 8, _hoisted_4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.messageData.user.name), 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getHumanFormatFromDateString(_ctx.messageData.created_at)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isOwn && !_ctx.messageData.is_group)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getHumanFormatFromDateString(_ctx.messageData.created_at)), 1),
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("img", {
                  alt: "Pic",
                  src: _ctx.messageData.user.photo
                }, null, 8, _hoisted_12)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(
          `p-5 rounded ${
            _ctx.isOwn ? 'bg-light-primary' : 'bg-light-info'
          }  text-dark fw-semobold mw-lg-400px text-start`
        )
      }, _toDisplayString(_ctx.messageData.body), 3)
    ], 2)
  ], 2))
}